import React, { useState } from 'react';
import { useNavigate } from '../../../hooks/useNavigate';
import {
  Box,
  IconButton,
  InputBase,
  Paper,
  Fade,
} from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import CloseIcon from '@mui/icons-material/Close';

export default function SearchBar() {
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');

  const handleToggle = () => {
    setOpen(!open);
    if (open) {
      setSearchTerm('');
    }
  };

  const handleSearch = (e: React.FormEvent) => {
    e.preventDefault();
    if (searchTerm.trim().length >= 3) {
      navigate(`/busca?q=${encodeURIComponent(searchTerm.trim())}`);
      setOpen(false);
      setSearchTerm('');
    }
  };

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
      <Fade in={open}>
        <Paper
          component="form"
          onSubmit={handleSearch}
          sx={{
            display: open ? 'flex' : 'none',
            alignItems: 'center',
            width: { xs: 200, sm: 300 },
            px: 2,
            py: 0.5,
            borderRadius: 20,
            boxShadow: 1,
          }}
        >
          <InputBase
            placeholder="Buscar..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            sx={{ flex: 1, fontSize: '0.875rem' }}
            autoFocus
          />
        </Paper>
      </Fade>

      <IconButton
        onClick={handleToggle}
        sx={{
          color: 'white',
        }}
        aria-label="buscar"
        size="small"
      >
        {open ? <CloseIcon fontSize="small" /> : <SearchIcon fontSize="small" />}
      </IconButton>
    </Box>
  );
}
